<script>
import { mapState, mapActions, mapGetters } from "vuex";

import NavigationWrapper from "@/components/NavigationWrapper";
import WattSliderModule from "@/components/WattSliderModule";
import AutoRefreshToggle from "@/components/AutoRefreshToggle";
import { getBreakpoint } from "@/utils";

export default {
  // Included components
  components: {
    NavigationWrapper,
    AutoRefreshToggle,
    WattSliderModule,
  },

  data() {
    return {
      facilityId: null,
    };
  },

  computed: {
    // The actual facility
    facility() {
      return this.facilities[this.facilityId];
    },

    // The group statistics
    statistics() {
      return this.groupStatistics[this.facility.group_id];
    },

    modules() {
      return this.facilityModules[this.facilityId];
    },

    // Other state mappings
    ...mapGetters(["can"]),
    ...mapState([
      "facilities",
      "facilityModules",
      "activeTeamId",
      "groupStatistics",
    ]),
  },

  // On creation fetch the group metadata, statistics, and hashrate
  async created() {
    this.facilityId = this.$route.params.facilityId;

    // Get this current facility
    await this.getFacility({ facilityId: this.facilityId });
    await this.getFacilityModules({ facilityId: this.facilityId });

    // If this group's team ID is not the active team ID, then go back to groups page
    if (this.facility.team_id !== this.activeTeamId) {
      await this.$router.push("/facilities");
      return;
    }

    this.updateStatistics();
  },

  methods: {
    // Update the group statistics (every 30 seconds if autorefresh is on)
    updateStatistics() {
      let fetches = [
        this.getGroupStatistics({ groupId: this.facility.group_id }),
      ];
      Promise.all(fetches);
    },

    // Helper methods and mapped vuex actions
    getBreakpoint,
    ...mapActions([
      "getFacility",
      "getFacilityModules",
      "updateFacility",
      "getGroupStatistics",
    ]),
  },
};
</script>

<template>
  <NavigationWrapper>
    <template #breadcrumbs>
      <b-breadcrumb-item to="/facilities">Facilites</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ facility.name }}</b-breadcrumb-item>
    </template>
    <b-row class="mb-3">
      <b-col cols="7">
        <h1>{{ facility.name }}</h1>
        <AutoRefreshToggle
          v-if="getBreakpoint().xs || getBreakpoint().sm"
          @update-30s="updateStatistics()"
        />
      </b-col>
      <b-col cols="5" :align-self="getBreakpoint().xs ? '' : 'center'">
        <div :class="getBreakpoint().xs ? '' : 'float-right'">
          <AutoRefreshToggle
            v-if="!(getBreakpoint().xs || getBreakpoint().sm)"
            @update-30s="updateStatistics()"
          />
        </div>
      </b-col>
    </b-row>

    <b-row
      v-for="(facilityModule, index) in Object.values(modules)"
      :key="index"
    >
      <b-col v-if="facilityModule.module_type === 'wattage_slider'">
        <WattSliderModule :facility="facility" :module="facilityModule" />
      </b-col>
    </b-row>
  </NavigationWrapper>
</template>
